<template>
  <div class="col-lg-12 col-md-12 col-sm-12 boton-panel" :key="datos.id">
    <md-card :md-with-hover="!validacion" md-theme="inverso">
      <md-ripple>
        <md-card-media-actions>
          <md-card-header>
            <div class="md-title" :title="datos.dt2">{{ datos.dt1 }}</div>
            <div class="md-subhead" v-if="datos.ndt3">
              <span class="precio-syb">{{ puntos(datos.ndt3) }}</span>
            </div>
          </md-card-header>
          <md-card-actions class="mb-3">
            <div>
              <md-checkbox :value="true" v-model="seleccion" v-on:change="seleccionar" :disabled="validacion" />
            </div>
          </md-card-actions>
        </md-card-media-actions>
      </md-ripple>
    </md-card>
  </div>
</template>

<script>
import constantes from "../constantes";

export default {
  name: "boton-cupon",
  data: () => ({
    vermas: false,
    seleccion: false,
    imagen: null,
    html: null,
    valor: []
  }),
  props: {
    datos: {
      type: Object,
      default: () => ({
        id: null,
        elements2: []
      })
    },
    value: {
      type: Array,
      default: () => ([])
    }
  },
  computed: {
    myBar: function () {
      return Object.assign({}, this.datos)
    },
    validacion:function() {
      const lleno = this.valor.length>0;
      let pose = -1;
      pose = this.valor.findIndex(item => item.id === this.datos.id);
      if(pose>=0){
        return false
      }else{
        return lleno;
      }
    }
  },
  methods: {
    minusculas: (texto) => constantes.funciones.minusculas(texto),
    puntos: (numero) => constantes.funciones.puntoMilesDecimal(numero),
    seleccionar: function () {
      let pose = -1;
      pose = this.valor.findIndex(item => item.id === this.datos.id);
      if (pose >= 0) {
        this.valor.splice(pose, 1);
        this.seleccion = false;
      } else {
        this.valor.push(this.datos);
        this.seleccion = true;
      }
      this.$emit('input', this.valor);
    }

  },
  created() {
    this.valor = this.value;
    let pose = this.value.findIndex(item => item.id === this.datos.id);
    this.seleccion = pose >= 0;

  },
  updated() {
    //this.validarSeleccion();
  }
}
</script>

<style scoped>
.boton-panel {
  padding-bottom: 15px;
}

.md-title {
  font-size: 1.2rem;
}

</style>
